<template>
  <div>
    <form @submit.prevent="submit">
      <h3>ACESSE SUA CONTA</h3>

      <!-- <div class="form-group d-flex">
        <button type="button" class="btn  btn-blue-facebook w-100 w-sm-50  m-1 btn-social text-white" @click="$emit('social', 'facebook', 'login')"><facebook-icon class="text-blue-facebook" />Facebook</button>
        <button type="button" class="btn  btn-blue-linkedin w-100 w-sm-50  m-1 btn-social text-white" @click="$emit('social', 'linkedin', 'login')"><linkedin-icon class="text-blue-linkedin" />Linkedin</button>
      </div> -->

      <p class="text-dark mt-4">
        Se você tem um perfil na Página de Carreiras do Gusmão & Labrunie ou na
        99jobs.com acesse com:
      </p>

      <div class="form-group">
        <FloatingLabel
          type="email"
          input-class="form-control form-control-xl bg-white border-blue-br"
          label="E-mail"
          v-model="username"
        />
      </div>

      <div class="form-group">
        <FloatingLabel
          type="password"
          input-class="form-control form-control-xl bg-white border-blue-br"
          label="Senha"
          v-model="password"
        />
      </div>

      <div class="form-group d-flex mb-5">
        <div
          class="
            custom-control
            custom-checkbox
            custom-checkbox-lg
            custom-checkbox-background
          "
        >
          <input
            type="checkbox"
            class="custom-control-input"
            id="keep-logged"
            v-model="keepLogged"
          />
          <label class="custom-control-label" for="keep-logged"
            >Lembrar de mim</label
          >
        </div>

        <div class="d-flex flex-column ml-auto text-right">
          <a
            href="#"
            class="text-blue-br font-weight-bold semi-small"
            @click.prevent="$emit('changeModal', 'password')"
            ><u>Esqueci minha senha</u></a
          >
          <a
            href="#"
            class="text-blue-br font-weight-bold semi-small mt-1"
            @click.prevent="$emit('changeModal', 'forgotUser')"
            ><u>Esqueci meu e-mail</u></a
          >
        </div>
      </div>

      <div class="text-center">
        <a
          href="#"
          class="text-black-50 font-weight-bold mr-3"
          @click.prevent="$emit('changeModal', 'preRegister')"
          >Ainda não tenho cadastro</a
        >
        <button type="submit" class="btn btn-dark px-4" :disabled="!canSubmit">
          Entrar
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import FacebookIcon from "vue-material-design-icons/Facebook.vue";
import LinkedinIcon from "vue-material-design-icons/Linkedin.vue";
import FloatingLabel from "@/components/FloatingLabel";

export default {
  name: "LoginForm",

  data() {
    return {
      username: "",
      password: "",
      keepLogged: false,
    };
  },

  computed: {
    canSubmit() {
      return (
        this.$helpers.isEmail(this.username) &&
        this.$helpers.validPassword(this.password)
      );
    },
  },

  components: {
    FacebookIcon,
    LinkedinIcon,
    FloatingLabel,
  },

  methods: {
    submit() {
      let current_profile = this.$store.state.deviseTrying;
      current_profile.email = this.username;
      current_profile.password = this.password;
      current_profile.keepLogged = this.keepLogged;
      current_profile.provider = null;
      current_profile.id = null;
      this.$store.commit("DEVISE_TRYING", current_profile);

      this.$emit("signIn");
    },
  },
};
</script>

<style lang="scss" scoped>
h3 {
  font-size: 1.7rem !important;
}
p {
  font-weight: 600 !important;
}
</style>
